import type { ExperimentConfigurationDeletionErrorResponse, RelatedExperiment } from "@globals";
import { array, literal, object, optional, safeParse, string } from "valibot";

const relatedExperimentSchema = object({
  id: string(),
  name: string(),
  status: string()
});

const experimentConfigurationDeletionErrorResponseSchema = object({
  message: string(),
  extra: object({
    error_type: literal("experiment_configuration_deletion_error"),
    related_experiments: optional(array(relatedExperimentSchema)),
    blocking_constraints: optional(array(string()))
  })
});

export function isExperimentConfigurationDeletionError(json: unknown): boolean {
  return safeParse(experimentConfigurationDeletionErrorResponseSchema, json).success;
}

export default class ExperimentConfigurationDeletionError extends Error {
  public extra: ExperimentConfigurationDeletionErrorResponse["extra"];

  constructor(
    readonly response: Response,
    readonly json: unknown
  ) {
    super(`ExperimentConfigurationDeletionError: ${response.status} ${response.statusText}`);
    const parsed = safeParse(experimentConfigurationDeletionErrorResponseSchema, json);
    if (parsed.success) {
      this.message = parsed.output.message;
      this.extra = parsed.output.extra;
    } else {
      console.error("Failed to parse ExperimentConfigurationDeletionError:", parsed.issues, json, response);
      this.extra = { error_type: "experiment_configuration_deletion_error" };
    }
  }

  get related_experiments(): RelatedExperiment[] | undefined {
    return this.extra.related_experiments;
  }

  get blocking_constraints(): string[] | undefined {
    return this.extra.blocking_constraints;
  }
}
